import React, { useEffect, useState } from "react"
import { Button, Card, Collapse, CardBody, CardText, CardTitle, Col, Row, Spinner, CardHeader } from "reactstrap"

import { useWallet } from "../../../libs/useMetaMaskWallet"
import Web3 from "web3"
import SimpleNFTSurvey from "../../../abi/surveys/SimpleNftSurveyERC20Alternative.json"
import IERC721Metadata from "../../../abi/IERC721Metadata/IERC721Metadata.json"
const NETWORKS = require("../../../constants/networks.json")

const Summary = ({ survey, active, onExpand, openForAnswer }) => {
    const web3 = new Web3()

    const [isLoading, setIsLoading] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)

    const [surveyData, setSurveyData] = useState([])
    const [isOpen, setIsOpen] = useState(true)
    const [numberQuestions, setNumberQuestions] = useState(0)
    const [totalAnswers, setTotalAnswers] = useState(0)
    const [requiredNfts, setRequiredNfts] = useState([])

    const wallet = useWallet()
    const linkToPool = `/surveys/?id=${survey.id}`

    useEffect(() => {
        let isSubscribed = true

        const fetchData = async () => {
            if (updateConnection() && wallet.account) {
                setIsLoading(true)
                try {
                    let provider = new Web3(NETWORKS[survey.network].providerUri)
                    let surveyContract = new provider.eth.Contract(SimpleNFTSurvey, survey.contractAddress)

                    let surveyData = await surveyContract.methods.getSurvey().call()

                    let required = []
                    for (let index = 0; index < surveyData.requiredNft.length; index++) {
                        let requiredNFT = new provider.eth.Contract(IERC721Metadata, surveyData.requiredNft[index])
                        let name = await requiredNFT.methods.name().call()
                        required.push({ name: name, address: surveyData.requiredNft[index] })
                    }

                    if (isSubscribed) {
                        setSurveyData(surveyData)

                        setIsOpen(surveyData.isOpen)

                        setNumberQuestions(surveyData.questions.length)

                        setTotalAnswers(surveyData?.totalAnswers?.toString())

                        setRequiredNfts(required)

                        openForAnswer(survey.id, surveyData.isOpen)
                    }

                    console.log("In summary:", surveyData)
                } catch (err) {
                    console.log(err)
                }
                setIsLoading(false)
            }
        }

        fetchData().catch(console.error)

        return () => (isSubscribed = false)
    }, [wallet])

    const updateConnection = () => {
        const x = wallet.status === "connected"
        setIsConnectedToWallet(x)
        return x
    }

    const Loading = () => {
        return <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
    }

    return (
        <React.Fragment>
            <Card className="stake-pool">
                <div>
                    <CardHeader
                        id="pool-header"
                        onClick={(e) => {
                            window.scrollTo({ behavior: "smooth", top: e.clientY + 100 })
                            onExpand(survey.id)
                        }}
                    >
                        {!isLoading ? (
                            <div>
                                <div className="info">{survey ? NETWORKS[survey.network].chainSymbol : "Loading"}</div>
                            </div>
                        ) : (
                            <Loading />
                        )}

                        <div className="info">
                            {isLoading ? <Loading /> : survey ? isLoading ? <Loading /> : surveyData.surveyTitle ?? "Survey Title" : "..."}
                        </div>
                        <div className="info">{isLoading ? <Loading /> : survey ? numberQuestions : "..."}</div>
                        <div className="info">{isLoading ? <Loading /> : survey ? totalAnswers : "..."}</div>
                        <div className="info">{isLoading ? <Loading /> : survey ? isOpen?.toString() : "..."}</div>
                    </CardHeader>

                    <Collapse isOpen={active === survey.id}>
                        <CardBody>
                            <div className="pool-body">
                                <Row>
                                    <Card>
                                        <CardBody>
                                            <CardTitle className="h3">Survey Details</CardTitle>

                                            <Row className="contract-details mt-md-4 mb-md-4 justify-content-between">
                                                <Col md={4} className="mt-3 mt-md-0">
                                                    <CardText className="card-text-label text-uppercase mb-1">Contract Address </CardText>
                                                    <div className="card-text-value">
                                                        <a
                                                            href={`${NETWORKS[survey.network].explorer}/address/${survey.contractAddress}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {survey.contractAddress.substring(0, 6) +
                                                                "..." +
                                                                survey.contractAddress.substring(survey.contractAddress.length - 4)}{" "}
                                                        </a>
                                                    </div>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-0">
                                                    <CardText className="card-text-label text-uppercase mb-1">Required NFTs </CardText>
                                                    <Col>
                                                        {requiredNfts.map((nft) => {
                                                            return (
                                                                <div key={nft.address} className="card-text-value">
                                                                    {isLoading ? <Loading /> : nft.name ?? "NFT Name"}
                                                                </div>
                                                            )
                                                        })}
                                                    </Col>
                                                </Col>

                                                <Col md={4} className="mt-3 mt-md-0">
                                                    <a href={linkToPool}>
                                                        <Button>View More</Button>
                                                    </a>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Row>
                            </div>
                        </CardBody>
                    </Collapse>
                </div>
            </Card>
        </React.Fragment>
    )
}

export default Summary
